import { MenuGroup } from "@portal/BaseComponents/Menu/type";
import { GenericRadioOptions } from "@portal/BaseComponents/Radio/types";
import { DefaultDocumentKeys, DocumentViews } from "./type";

const customerFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Customer",
    key: "Customer",
    children: [],
  },
];
const InvoiceFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Invoice",
    key: "Invoice",
    children: [],
  },
];

export const documentFilterGroups = [
  ...customerFilterGroups,
  ...InvoiceFilterGroups,
];

export const defaultDocumentKeys: DefaultDocumentKeys[] = [
  "date_range",
  "types",
  "from_date",
];
export const documentViewOptions: GenericRadioOptions<DocumentViews> = [
  {
    label: "All",
    value: "ALL",
  },
  { label: "Customer", value: "CUSTOMER" },
  {
    label: "Invoice",
    value: "INVOICE",
  },
];
